import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import Select from "react-select";
import * as Common from "../../Common";
import Dialog from "../../Dialog";

function MasterLedgerCommission({ commissionList, updateCommissionList, ldgsrno, ldggrpsrno, visiblePg, deleteRight }) {
    const sid = sessionStorage.getItem("sessionId");

    const [commProduct, setCommProduct] = useState("");
    const [commType, setCommType] = useState("");
    const [commValue, setCommValue] = useState("");
    const [commList, setCommList] = useState([]);
    const [isdOptions, setIsdOptions] = useState([]);
    const [isd, setIsd] = useState({ value: "", label: "Select" });
    const [commlineno, setCommlineno] = useState(0);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    useEffect(() => {
        setCommList(commissionList);
    }, [commissionList]);

    const validateFields = () => {
        const errors = [];
        if (!commProduct) errors.push("Product");
        if (!commType) errors.push("Type");
        if (!isd.value) errors.push("ISD");
        if (!commValue) errors.push("Value");

        if (errors.length > 0) {
            const errorMessage = Common.buildMessageFromArray([Common.getMessage("MSG0006"), ...errors]);
            setMsgText(errorMessage);
            setMsgBox(true);
            return false;
        }
        return true;
    };

    const addCommission = () => {
        if (!validateFields()) return;
        let lineNo = commlineno + 1;
        const newCommission = {
            vlc_srno: lineNo,
            vlc_product: commProduct,
            vlc_type: commType,
            vlc_value: commValue,
            vlc_isd: isd.value,
            vlc_ldgsrno: ldgsrno,
            vlc_group: ldggrpsrno,
        };
        setCommList((prevCommList) => {
            const obj = prevCommList.filter((item) => {
                const vlcProduct = item.vlc_product?.trim() || ""; // Safe trim
                const vlcType = item.vlc_type?.trim() || "";
                const vlcIsd = item.vlc_isd?.trim() || "";
                return (
                    vlcProduct !== commProduct.trim() || // Filter commProduct
                    vlcType !== commType.trim() ||
                    vlcIsd !== isd.value.trim()
                );
            });
            let updatedList = [];
            if (commProduct.trim() === "A") {
                const furtherFilteredList = obj.filter((item) => {
                    const vlcProduct = item.vlc_product?.trim() || "";
                    const vlcType = item.vlc_type?.trim() || "";
                    const vlcIsd = item.vlc_isd?.trim() || "";
                    return !(
                        (vlcProduct === "CN" || vlcProduct === "VTM") &&
                        vlcType === commType.trim() &&
                        vlcIsd === isd.value.trim()
                    );
                });
                const objCN = { ...newCommission, vlc_product: "CN", vlc_srno: lineNo++ };
                const objVTM = { ...newCommission, vlc_product: "VTM", vlc_srno: lineNo++ };

                updatedList = [...furtherFilteredList, objCN, objVTM];
            } else {
                updatedList = Common.arrayAddItem(obj, newCommission);
            }
            updateCommissionList(updatedList);
            return updatedList;
        });
        setCommlineno(lineNo + 1);
        resetFields();
    };


    const resetFields = () => {
        setCommProduct("");
        setCommType("");
        setCommValue("");
        setIsd({ value: "", label: "Select" });
    };

    const deleteCommission = (srno) => {
        const updatedList = commList.filter((item) => item.vlc_srno !== srno);
        setCommList(updatedList);
        updateCommissionList(updatedList);
        setCommlineno((prevLineNo) => prevLineNo - 1);
    };

    const handleProductChange = (value) => {
        setCommProduct(value);
        if (value === "TT") {
            setCommType("P");
        }
        Common.callApi(Common.apiLedger, [sid, "getisd", value], (result) => {
            setIsdOptions(JSON.parse(result));
        });
    };

    return (
        <div>
            <Row>
                <Col>
                    <h3>Commission</h3>
                </Col>
            </Row>

            {visiblePg !== "Q" && (
                <>
                    <Row>
                        <Col md={3} sm={6}>
                            <Form.Group>
                                <Form.Label>
                                    Product<span className="colorThemeRed">*</span>
                                </Form.Label>
                                <Form.Select
                                    value={commProduct}
                                    onChange={(e) => handleProductChange(e.target.value)}
                                >
                                    <option value="">Select</option>
                                    {/* <option value="A">All</option> */}
                                    <option value="CN">Currency</option>
                                    <option value="VTM">VTM</option>
                                    <option value="TT">TT</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col md={3} sm={6}>
                            <Form.Group>
                                <Form.Label>
                                    Type<span className="colorThemeRed">*</span>
                                </Form.Label>
                                <Form.Select
                                    value={commType}
                                    onChange={(e) => setCommType(e.target.value)}
                                    disabled={commProduct === "TT"}
                                >
                                    <option value="">Select</option>
                                    <option value="P">Paise</option>
                                    <option value="R">Percentage</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col md={3} sm={6}>
                            <Form.Group>
                                <Form.Label>
                                    ISD<span className="colorThemeRed">*</span>
                                </Form.Label>
                                <Select
                                    options={isdOptions}
                                    value={isd}
                                    onChange={(v) => setIsd(v)}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={3} sm={6}>
                            <Form.Group>
                                <Form.Label>
                                    Value<span className="colorThemeRed">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Value"
                                    value={commValue}
                                    onChange={(e) =>
                                        Common.validateDecValue(e.target.value, setCommValue)
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mt-2">
                        <Col>
                            <Button variant="outline-primary" size="sm" onClick={addCommission}>
                                Add
                            </Button>
                        </Col>
                    </Row>
                </>
            )}

            <Row className="mt-3">
                <Col>
                    <Table responsive bordered striped>
                        <thead>
                            <tr>
                                <th>&nbsp;</th>
                                <th>Product</th>
                                <th>Type</th>
                                <th>ISD</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {commList.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        {
                                            visiblePg === "Q" || deleteRight === "0" ? null :
                                                <span
                                                    className="colorThemeBlue"
                                                    onClick={() => deleteCommission(item.vlc_srno)}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </span>
                                        }
                                    </td>
                                    <td>{item.vlc_product}</td>
                                    <td>{item.vlc_type === "P" ? "Paise" : "Percentage"}</td>
                                    <td>{item.vlc_isd}</td>
                                    <td>{item.vlc_value}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Col>
            </Row>

            <Dialog isOpen={isMsgBox} onClose={() => setMsgBox(false)}>
                {msgText}
            </Dialog>
        </div>
    );
}

export default MasterLedgerCommission;
